(function (root) {
  'use strict';
  const VISUAL_ANCHOR_QUANTITY = 41;
  const VISUAL_ANCHOR_PERCENT = 30;
  const VISUAL_STEP = 0.9;
  const TTL = 75 * 60 * 1000;
  const identity = {variantId:'gid://shopify/ProductVariant/51881814327638',inventoryItemId:'gid://shopify/InventoryItem/54195573293398',locationId:'gid://shopify/Location/90944930134',sku:'2506-stove1.8-black'};
  function valid(snapshot, now) {
    if (!snapshot || snapshot.valid !== true || !Number.isSafeInteger(snapshot.quantity) || snapshot.quantity <= 0) return false;
    if (!Object.entries(identity).every(([key,value]) => snapshot[key] === value)) return false;
    const at = Date.parse(snapshot.checkedAt);
    return Number.isFinite(at) && at <= now && now - at < TTL;
  }
  function displayQuantity(snapshot, adjustment, now) {
    if (!valid(snapshot, now) || !Number.isSafeInteger(adjustment)) return null;
    const quantity = snapshot.quantity + adjustment;
    return Number.isSafeInteger(quantity) && quantity > 0 ? quantity : null;
  }
  function fill(quantity) {
    if (!Number.isSafeInteger(quantity) || quantity < 0) return null;
    if (quantity === 0) return 0;
    return Math.min(100, VISUAL_ANCHOR_PERCENT * VISUAL_STEP ** (VISUAL_ANCHOR_QUANTITY - quantity));
  }
  function choose(previous, next) {
    // Reject stale responses without preventing legitimate restocks.
    if (previous && next && Date.parse(next.checkedAt) < Date.parse(previous.checkedAt)) return previous;
    return next;
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports={valid,choose,fill,displayQuantity,TTL,identity}; return; }
  if (customElements.get('bast-stock-counter')) return;
  customElements.define('bast-stock-counter',class extends HTMLElement {
    connectedCallback() {
      this.hidden=true; this.snapshot=null; this.enabled=false; this.adjustment=0; this.busy=false;
      this.config=JSON.parse(this.querySelector('[data-bast-config]').textContent);
      this.visibility=()=>{this.draw(); if(!document.hidden) this.refresh();};
      document.addEventListener('visibilitychange',this.visibility);
      this.timer=setInterval(()=>this.draw(),1000);
      this.poll=setInterval(()=>{if(!document.hidden)this.refresh();},60000);
      this.refresh();
    }
    disconnectedCallback() {
      clearInterval(this.timer);clearInterval(this.poll);
      document.removeEventListener('visibilitychange',this.visibility);
      this.abort?.abort();
    }
    now() { return this.serverTime === undefined ? Date.now() : this.serverTime + performance.now()-this.receivedAt; }
    draw() {
      const quantity=displayQuantity(this.snapshot,this.adjustment,this.now());
      this.hidden=!(this.enabled && quantity!==null);
      if(this.hidden)return;
      const formatted=new Intl.NumberFormat(document.documentElement.lang).format(quantity);
      this.querySelector('[data-bast-count]').textContent=formatted;
      this.querySelector('[data-bast-fill]').style.width=fill(quantity)+'%';
    }
    async refresh() {
      if(this.busy || !this.isConnected)return;
      this.busy=true; this.abort=new AbortController();
      const timeout=setTimeout(()=>this.abort.abort(),10000);
      try {
        const url=new URL(location.href);
        url.searchParams.set('section_id','bast-stock-snapshot');
        url.searchParams.set('_bast_check',String(Date.now()));
        const response=await fetch(url,{cache:'no-store',credentials:'same-origin',signal:this.abort.signal});
        if(!response.ok)throw new Error('Snapshot unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        let data;
        try { data=JSON.parse(doc.querySelector('[data-bast-snapshot]').textContent); }
        catch (_) { this.snapshot=null; throw new Error('Invalid snapshot payload'); }
        if(String(data.productId)!==this.config.productId)throw new Error('Product mismatch');
        const server=Date.parse(response.headers.get('Date'));
        const observed=Number.isFinite(server)?server:Date.now();
        this.serverTime=this.serverTime===undefined?observed:Math.max(this.now(),observed);
        this.receivedAt=performance.now();
        this.enabled=data.enabled===true;
        this.adjustment=data.adjustment;
        // Invalid/missing new data must hide the claim, even if previous was positive.
        this.snapshot=choose(this.snapshot,data.snapshot);
      } catch (_) { /* Never renew freshness after failure. */ }
      finally {clearTimeout(timeout);this.busy=false;this.draw();}
    }
  });
})(typeof globalThis !== 'undefined' ? globalThis : this);
